export default __webpack_public_path__ + "static/header-background-144498c9dbf4ba964d6f9e1bc2de1959.jpg";